import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resolveBackPath } from '../utils/routeParents';

const readUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch {
    return null;
  }
};

/**
 * Returns a stable `goBack` callback that resolves the logical parent
 * of the current route via `routeParents.js`. The optional `override`
 * lets a page provide custom back behaviour (wizard step → previous
 * step, conditional flows, etc.) without giving up the hook.
 *
 *   const goBack = useBackTarget();          // → uses parent map
 *   const goBack = useBackTarget('/x/y');    // → forces a target
 *   const goBack = useBackTarget(() => ...); // → fully custom
 */
export const useBackTarget = (override) => {
  const location = useLocation();
  const navigate = useNavigate();

  return useCallback(() => {
    if (typeof override === 'function') return override();
    if (typeof override === 'string') return navigate(override);
    const target = resolveBackPath(location.pathname, readUser());
    navigate(target);
  }, [location.pathname, navigate, override]);
};

export default useBackTarget;
